import React from "react";
import {Helmet} from "react-helmet";
import MedicineForm from "../../components/idp-medicine/form";
import "../../assets/css/idp-medical.css";

const IdpMedicine = () => {
  return (<>
    <Helmet>
        <title>IDP Medical</title>
    </Helmet>
    <div className="idp_wrapper">
      <div className="idp_container">
        <div className="idp_bg_wrapper">
          <div className="idp_map_inner column_direction">
            <div className="idp_hading_block">
              <div className="logo_blk">
                <img src={require("../../assets/images/logo.png")} alt="" />
              </div>
              <h1>Fill in Your Preferences</h1>
              <p>We'll Guide You with the Right Information</p>
            </div>
            <img src={require("../../assets/images/left_img.png")} alt="" />
          </div>
        </div>
        <div className="idp_form_wrapper">
          <div className="idp_abrod_about_us">
            <h2 className="about_us_heading">
              Help us
              <br /> <strong>Personalize</strong> your{" "}
              <strong>experience</strong>
            </h2>
            <p className="idp_breif">
              Fill correct information to receive guidance that fits your interest and goal.
            </p>
          </div>

          <MedicineForm />
        </div>
      </div>
    </div>
    </>);
};

export default IdpMedicine;
